const CounsellingSchema = {
    feilds: [
        {
            id: 0,
            name: 'tokennumber',
            title: 'token number',
            visible: true,
            element: 'label',
            className: [],
            required: false
        }, {
            id: 1,
            name: 'service_type',
            title: 'Service Type',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Financial Counselling',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Select Service Type'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        },
        {
            id: 16,
            name: 'covidstatus',
            title: 'Covid status of the patient',
            visible: false,
            element: 'text',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        },
        {
            id: 18,
            name: 'non-covid',
            title: 'Non-Covid',
            visible: false,
            element: 'radio',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value:'Non-Covid' ,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        } ,    
        {
            id: 19,
            name: 'covid-ip',
            title: 'Covid-IP',
            visible: false,
            element: 'radio',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3'
        } ,     
        {
            id: 20,
            name: 'covid-daycare',
            title: 'Covid-DayCare',
            visible: false,
            element: 'radio',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-5'
        },   
        {
            id: 22,
            name: 'covid-icu',
            title: 'Covid-ICU',
            visible: false,
            element: 'radio',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-3 mb-5'
        },  
        {
            id: 3,
            name: 'skip',
            title: 'Skip',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false
        }, {
            id: 4,
            name: 'continue',
            title: 'Continue',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false
        },
    ]
};

const PatientNotAvailable = {
    feilds: [{
        id: 1,
        name: 'reason_dropdown',
        title: 'Reason Dropdown',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Reason Dropdown',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Reason Dropdown'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3'
    }

    ]
}
const PatientCameOther = {
    feilds: [{
        id: 1,
        name: 'reason_dropdown',
        title: 'Select Reason',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Reason Dropdown',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Reason Dropdown'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-12'
    }, {
        id: 2,
        name: 'financial_couselling_skip',
        title: 'Service Type',
        visible: false,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Financial Counselling',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    //return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Service Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-12'
    }

    ]
}

const searchData = {
    feilds: [
        {
            id: 12,
            name: 'name',
            title: 'Name',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 14,
            name: 'umr_number',
            title: 'UMR',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 17,
            name: 'ip',
            title: 'IP',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 16,
            name: 'phone_number',
            title: 'Phone Number',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 15,
            name: 'gender',
            title: 'Gender',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 16,
            name: 'age',
            title: 'Age',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }, {
            id: 16,
            name: 'doctor_name',
            title: 'Doctor',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        },
        {
            id: 16,
            name: 'counselling_station',
            title: 'Counselling Station',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Enter',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-4'
        }


    ]
}

export { CounsellingSchema, PatientNotAvailable, PatientCameOther, searchData };